import request from './axios.js';
import md5 from "crypto-js/md5"               

const api = {
    // 支付
    payModule :{
        goPay(requestConfig) {
            requestConfig.params.key = 1000006;
            if(requestConfig.needSignature) {
                let singatureStr = `/pay
                                    ${requestConfig.params.channel}
                                    ${requestConfig.params.client}
                                    ${requestConfig.params.goodId}
                                    ${requestConfig.params.key}
                                    ${requestConfig.params.openid}
                                    ${requestConfig.params.source}
                                    ${requestConfig.params.totalFee}
                                    7ece94d9f9c202b0d2ec557dg4r9bc
                                    `.trim();
                
                // console.log(singatureStr.replace(/[\r\n]/g,"").replace(/\ +/g,""))
                singatureStr = md5(singatureStr.replace(/[\r\n]/g,"").replace(/\ +/g,"")).toString();    
                // console.log(singatureStr)
                requestConfig.params.signature = singatureStr;
            }
            // 
            return request.request('/pay',{
                method:'get',
                params:requestConfig.params,
            })
        },
        queryPaystate(requestConfig) {
            requestConfig.params.key = 1000006;
            if(requestConfig.needSignature) {
                let singatureStr = `/order/query
                                    ${requestConfig.params.key}
                                    ${requestConfig.params.tradeNo}
                                    7ece94d9f9c202b0d2ec557dg4r9bc
                                    `.trim();
                // console.log(singatureStr.replace(/[\r\n]/g,"").replace(/\ +/g,""))
                singatureStr = md5(singatureStr.replace(/[\r\n]/g,"").replace(/\ +/g,"")).toString();    
                // console.log(singatureStr)
                requestConfig.params.signature = singatureStr;
            }
            return request.request('/order/query',{
                method:'get',
                params:requestConfig.params,
            })
        },
        queryPrice(requestConfig) {
            return request.request('/api/vip/list',{
                baseURL:requestConfig.baseURL,
                method:'get',
                params:requestConfig.params,
            }
            )
        }
    }
}
export default api;